import type { DecryptStatus } from '../constants';
import type { IPaySuccess } from './payTypes';
import type { ECardType } from '../utils/config';
import { ComponentPropsWithoutRef } from 'react';

export const ValidFieldTypes = {
  CARD_NUMBER: 'card-number',
  EXPIRATION_DATE: 'expiration-date',
  CVV: 'cvv',
  ROUTING: 'routing',
  ACCOUNT_NUMBER: 'account-number',
  CARD_FEE: 'card-fee',
  ACH_FEE: 'ach-fee',
  APPLE_PAY: 'apple-pay',
  GOOGLE_PAY: 'google-pay',
  TUAPAY: 'tuapay',
  TUAPAY_FRAME_CONTAINER: 'tuapay-frame-container',
} as const;

export type FieldType = (typeof ValidFieldTypes)[keyof typeof ValidFieldTypes];

export type SuccessDecryption = {
  status: typeof DecryptStatus.SUCCESS;
  data?: IPaySuccess;
};

export type FailedDecryption = {
  status: typeof DecryptStatus.FAILED | typeof DecryptStatus.CANCELLED;
  message?: string;
};

export type DecryptionData = SuccessDecryption | FailedDecryption;

export type FieldComponentProps = {
  currentLanguage?: string;
  isFetching: boolean;
  toggleFetching: (val: boolean) => void;
  handleCardTypeChange: (potentialCardType: ECardType | null) => void;
  potentialCardType: ECardType | null;
  sendApplePayTokenToLib: (decryptionData: DecryptionData) => void;
  sendGooglePayTokenToLib: (decryptionData: DecryptionData) => void;
  openTuaPayFrame: (url?: string, error?: unknown) => void;
  notifyTuaPayBtnClicked?: () => void;
  notifyGooglePayBtnClicked?: () => void;
  notifyApplePayBtnClicked?: () => void;
  updateHeight?: () => void;
};

export type TSecurityCodeProps = ComponentPropsWithoutRef<'div'> & { show: boolean; handleShow: (isShow?: boolean) => void };
